import './Link.scss';

const Link = ({url, text}) => (
    <a className="link-component" href={url || '#'} rel="noreferrer" target="_blank">{text}</a>
);

export default Link;
